import { Link } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Grid,
} from '@mui/material';
import {
  Receipt as FacturaIcon,
  PendingActions as PendientesIcon,
  CheckCircle as FacturadosIcon,
  Business as ClientesIcon,
} from '@mui/icons-material';

const FacturacionIndex = () => {
  const modules = [
    {
      title: 'Panel de Facturación',
      description: 'Ver y facturar vuelos cerrados',
      link: '/facturacion/panel',
      icon: FacturaIcon,
      gradient: 'linear-gradient(135deg, #7B1FA2 0%, #6A1B9A 100%)',
    },
    {
      title: 'Pendientes',
      description: 'Vuelos cerrados sin facturar',
      link: '/facturacion/panel?estado=pendientes',
      icon: PendientesIcon,
      gradient: 'linear-gradient(135deg, #F57C00 0%, #E65100 100%)',
    },
    {
      title: 'Facturados',
      description: 'Vuelos ya facturados',
      link: '/facturacion/panel?estado=facturados',
      icon: FacturadosIcon,
      gradient: 'linear-gradient(135deg, #388E3C 0%, #2E7D32 100%)',
    },
    {
      title: 'Clientes Facturación',
      description: 'Gestionar clientes de facturación',
      link: '/facturacion/clientes',
      icon: ClientesIcon,
      gradient: 'linear-gradient(135deg, #1976D2 0%, #1565C0 100%)',
    },
  ];

  return (
    <Box>
      {/* Header */}
      <Card
        sx={{
          mb: 4,
          background: 'linear-gradient(135deg, #7B1FA2 0%, #9C27B0 100%)',
          color: 'white',
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <FacturaIcon sx={{ fontSize: 48 }} />
            <Box>
              <Typography variant="h4" fontWeight="bold" gutterBottom>
                Facturación
              </Typography>
              <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
                Gestión de facturación de vuelos cerrados
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* Modules Grid */}
      <Grid container spacing={3}>
        {modules.map((module) => {
          const IconComponent = module.icon;
          return (
            <Grid item xs={12} sm={6} lg={3} key={module.title}>
              <Card
                sx={{
                  height: '100%',
                  transition: 'all 0.3s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6,
                  },
                }}
              >
                <CardActionArea
                  component={Link}
                  to={module.link}
                  sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
                >
                  <Box
                    sx={{
                      background: module.gradient,
                      p: 3,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <IconComponent sx={{ fontSize: 48, color: 'white' }} />
                  </Box>
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {module.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {module.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default FacturacionIndex;




